import { ItemType, NavigationItem } from '../../../../models/Navigation';

export const dealsDropdownOptions: NavigationItem[] = [
  {
    type: ItemType.NAVLINK,
    text: 'Bonds',
    to: '/deals-pipeline/bond',
  },
  {
    type: ItemType.NAVLINK,
    text: 'Loans',
    to: '/deals-pipeline/loans',
  },
];
